import { catalogoApi } from '../services/api';

// docs: https://catalog-svc-dev.telemedicinaeinstein.com.br/docs/
export const fetchBranches = async (limit: number) => {
  const response = await catalogoApi.get('branch', {
    params: { limit }
  });

  const { data } = response;
  return data;
};

export const fetchBrancheById = async (id: string) => {
  const response = await catalogoApi.get(`branch/${id}`);
  const { data } = response;
  return data;
};
